import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import CprChart from './CprChart'
import CprStatCards from './CprStatCards'
import {
  Paper,
  Card,  
  Typography,
  Select,
  CardHeader,
  CardContent,
  Avatar,  
  CircularProgress,
  Divider,
  MenuItem,
} from '@material-ui/core'
import { Favorite, CreditCard, LocalAtm, PermContactCalendar } from '@material-ui/icons'
import CprLine from './CprLine'
import CprTotalsByYear from './CprTotalsByYear'
import moment from 'moment'
import PageHeader from '../PageHeader'

const CprStats = (props) => {
  const { dark } = props
  const currentUser = JSON.parse(localStorage.getItem("currentUser"))[0]
  const token = Cookies.get("token")
  const [metricData, setMetricData] = useState(null)
  const [companyData, setCompanyData] = useState(null)
  const [marketData, setMarketData] = useState(null)
  const [locationData, setLocationData] = useState(null)
  const [companySelected, setCompanySelected] = useState("ALL")
  const exceptions = ["FURNITUREMART"]    

  const getCprData = () => {
    let lowerSectIcons = [<PermContactCalendar size="small"/>, <CreditCard size="small"/>, <LocalAtm size="small"/>]
    let lowerSectColors = ['#cf9af5', '#ffa938', '#6ac900']
    
    const request = Promise.all([
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/cpr/stats/market`, {headers: {"token": token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/cpr/stats/location`, {headers: {"token": token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/cpr/metricsYOY`, {headers: {"token": token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/cpr/metricsYOY?company=1`, {headers: {"token": token}}),
    ])

    request.then(([response, response2, response3, response4]) => Promise.all([response.json(), response2.json(), response3.json(), response4.json()]))
    .then(([data, data2, data3, data4]) => {
      setMarketData(data)
      setLocationData(data2)
      setMetricData(data3)
      data4.forEach((element, i) => {
        element.icon = lowerSectIcons[i]
        element.color = lowerSectColors[i]
      })
      setCompanyData(data4)      
    })
  }
  
  useEffect(() => getCprData(), [])

  const getSeries = (data) => {
    let current = moment().diff(moment().startOf("year"), "months") > 3    
    let years = data.map(({Data}) => Data.map(({Year}) => Year).filter(item => item !== "Historical" && item > moment().subtract(6, "years").format("YYYY")))[0]
    const series = []    

    for(let i = 0; i < years.length; i++) {
      let dataObj = {}
      dataObj["name"] = years[i]
      dataObj["data"] = []
      for(let j = 0; j < data.length; j++) {
        for(let k = 0; k < data[j].Data.length; k++) {
          if(years[i] === data[j].Data[k].Year) dataObj["data"].push(data[j].Data[k].Customers)
        }
      }
      series.push(dataObj)
    }

    return series.reverse()
  }

  const handleSelectCompany = e => {
    const { value } = e.target
    setCompanySelected(value)    
  }

  const getCompanyList = data => {
    let companyList = []

    for(let i = 0; i < data.length; i++) {
      for(let j = 0; j < data[i].Data.length; j++) {
        if(companyList.indexOf(data[i].Data[j].Company) === -1) {
          companyList.push(data[i].Data[j].Company)
        }
      }
    }

    return companyList
  }

  const getCompanySplitSeries = (data) => {
    let dataSelected = []
    const series = [
      {name: "Population Average", data: [], attr_name: "Pop"}, 
      {name: "Customer Average", data: [], attr_name: "Cust"}
    ]

    if(exceptions.includes(currentUser.db_owner)) {
      if(!companySelected.includes("ALL")) dataSelected = data.filter(({Company}) => Company === companySelected)
      else {
        let years = []
        let attrs = ["Pop", "Cust"]

        for(let i = 0; i < data.length; i++) {          
          if(!years.map(({year}) => year).includes(data[i].Year)) years.push({year: data[i].Year})
        }
                
        for(let i = 0; i < years.length; i++) {
          for(let j = 0; j < attrs.length; j++) {
            years[i][`${attrs[j]}_Average`] = 0
            years[i][`${attrs[j]}_Count`] = 0
            for(let k = 0; k < data.length; k++) {
              if(years[i].year === data[k].Year) {
                years[i][`${attrs[j]}_Average`] += (data[k][`${attrs[j]}_Average`] * data[k][`${attrs[j]}_Count`])
                years[i][`${attrs[j]}_Count`] += data[k][`${attrs[j]}_Count`]
              }
            }
            years[i][`${attrs[j]}_Average`] = years[i][`${attrs[j]}_Count`] > 0 ? years[i][`${attrs[j]}_Average`]/years[i][`${attrs[j]}_Count`] : null              
          }              
        }
        dataSelected = years
      }
    } else {
      dataSelected = [...data]
    }
    
    series.forEach(element => {
      let propName = `${element.attr_name}_Average`
      element.data = dataSelected.map(item => item[propName])
    })    
    
    return series    
  }

    if(!marketData || !metricData || !locationData || !companyData) return <CircularProgress />
  
    return (
      <div id="cpr">        
        <PageHeader details={{title: "CPR STATS", icon: <Favorite />}}/>
        <br/>
        <CprStatCards darkMode={dark} data={marketData} metric={metricData}/>
        <div className="upper-section">          
          <Paper className={`cpr-chart ${dark ? "bg-dk" : "bg-lt"}`}>              
            <CprChart
              series={getSeries(locationData)}
              categories={locationData.map(({Label}) => Label)}                  
              title={'Customers By Year'}
              yTitle={'Customer Counts'}
              darkMode={dark}
              height={"725px"}
            />
          </Paper>
          <Paper className={`cpr-table ${dark ?  "bg-dk" : "bg-lt"}`}>
            <CprTotalsByYear data={getSeries(locationData)} darkMode={dark}/>              
          </Paper>
        </div>
        
        <Card className={`lower-section ${dark ?  "bg-dk" : "bg-lt"}`}>
          <div style={exceptions.includes(currentUser.db_owner) ? {position: 'absolute', right: 15, marginTop: 15} : {display: 'none'}}>
            <Select
              variant="outlined"
              style={{width: '250px'}}
              onChange={handleSelectCompany}
              value={companySelected}
              className={dark ? "cpr-select-dk dk" : "cpr-select-lt lt"}
            >
              <MenuItem value={'ALL'}><Typography variant="caption">ALL BRANDS</Typography></MenuItem>
              {getCompanyList(companyData).map((option, i) => (
                <MenuItem key={i} value={option}><Typography variant="caption">{option.toUpperCase()}</Typography></MenuItem>
              ))}                    
            </Select>                  
          </div>                             
          {companyData.map(({Data, MetricType, color, icon}, i) => (
            <div key={i} className="graphs">
              <div style={{width: "100%"}}>
                <CardHeader
                  avatar={<Avatar style={{backgroundColor: 'transparent', color: color}}>{icon}</Avatar>}
                  title={<Typography variant="body2" style={{fontWeight: 'bold'}}>{MetricType.toUpperCase()}</Typography>}
                  style={{color: color, height: 60}}
                />
                <CardContent>                          
                  <CprLine                            
                    series={getCompanySplitSeries(Data)}                            
                    categories={metricData.map(item => item.Data.map(item => item.Year))[2]}
                    xTitle={'Year'}
                    yTitle={MetricType}
                    darkMode={dark}
                  />
                </CardContent>
              </div>
              <Divider orientation="vertical" style={i < companyData.length - 1 ? { backgroundColor: '#4292c6'} : {display: 'none'}}/>
            </div>
          ))}
        </Card>            
      </div>
    )
  }


export default CprStats
